
export function Translate(textEn: string, textKh: string): string {
    const defaultLanguage = localStorage.getItem('camedu-language')
    return defaultLanguage === 'EN' || undefined ? textEn : textKh
}

export function getLocalTranslate(keyword: string, defaultText: string): string {
    let localTranslate = JSON.parse(localStorage.getItem('local-translate'))
    if (localTranslate) {
        let translate = localTranslate[keyword]
        return translate === undefined ? defaultText : Translate(translate.textEn, translate.textKh)
    }else{
        return defaultText
    }

}